module.exports = __webpack_public_path__ + "static/media/sarev.4649e1d1.png";